export * from "./masks"
export * from "./snake-to-camel-case"
export * from "./camel-to-snake-case"
export * from "./get-union-literals"
export * from "./supported-currencies"
export * from "./option"

export const INVISIBLE_CHAR = "‎ "
export const DATE_FORMAT_TO_SEND = "YYYY-MM-DD"
export const DATE_FORMAT_TO_SHOW = "DD/MM/YYYY"
export const LONG_DATE_WITH_HOURS_FORMAT_TO_SHOW = "MMM D, YYYY, h:mm:ss A"
export const LONG_DATE_FORMAT_TO_SHOW = "MMM D, YYYY"
export const SHORT_DATE_WITH_HOURS_FORMAT_TO_SHOW = "DD/MM HH:mm"

type Falsy = undefined | null | false | 0 | ""
export const not = <T>(value: T | Falsy): value is Falsy => {
  return !value
}

export function invariant(
  condition: unknown,
  message: string,
): asserts condition {
  if (condition) return
  throw new Error(message)
}

export const truncate = (
  value: string,
  options: { length: number },
): string => {
  if (value.length <= options.length) {
    return value
  }
  return value.substring(0, options.length) + "..."
}

export function getValueOrEmptyText(value?: string | null): string {
  return value || "---"
}

export function isNumbersTheSame(a: string, b: string): boolean {
  return onlyNumbers(a) === onlyNumbers(b)
}

export function onlyNumbers(data: string): number {
  return +data.replace(/\D+/g, "")
}

export function isEmail(value: string): boolean {
  const minimumEmailRegex =
    /^[a-zA-Z0-9](?:.*[a-zA-Z0-9])?@[a-zA-Z0-9](?:.*[a-zA-Z0-9])?$/
  return minimumEmailRegex.test(value)
}

export function sleep(time: number) {
  return new Promise(resolve => {
    setTimeout(resolve, time)
  })
}

export function validateEmail(value: string) {
  const validInputValue = value.trim().replace(/,$/, "").trim()
  return isEmail(validInputValue) ? validInputValue : null
}
